export const peopleSorter = (a, b) => {
  if (!a.last_name) {
    if (!b.last_name) {
      return 0
    }
    return 1
  }

  if (!b.last_name) {
    return -1
  }

  if (a.last_name < b.last_name) {
    return -1
  }

  if (b.last_name < a.last_name) {
    return 1
  }

  return 0
}

export const getValidPeople = (people, items, taskType) => {
  const userMap = (items || []).map((item) => {
    if (item.to_user || item.proxy_user) {
      return item.to_user.id || item.proxy_user.id
    }
    return null
  })

  const filteredPeople = userMap.reduce(
    (acc, current) =>
      acc.filter((item) => {
        if (item.role_system_name === 'view_only') return false
        if (
          taskType === 'approval' &&
          parseInt(current, 10) === parseInt(item.id, 10)
        )
          return false
        return true
      }),
    people
  )

  return filteredPeople.sort(peopleSorter)
}
